import "./styles.scss";

import classnames from "classnames";

const mainClass = "dropdown-card";

const DropdownCard = ({ children, position, variant }) => {
  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--${position}`]: !!position,
        [`${mainClass}--${variant}`]: !!variant,
      })}
    >
      {children}
    </div>
  );
};

export default DropdownCard;
